export default ({
  state: {
    // Mesa Ayuda - Soliciudes
    MesaAyudaFilterForm: [
      { field: 'selectDataServer', name: 'Usuarios', nameid: 'usuario_id', url: '/empresa/usuarios', value: 'empleado_id', cols: 4 },
      { field: 'selectDataServer', name: 'Tipo Actividad', nameid: 'tipo_proceso_id', url: '/empresa/tipo-actividades/show-solicitudes', cols: 4 },
      { field: 'selectDataServer', name: 'Tipo Servicio', nameid: 'servicio', url: '/catalogo/tipos-atencion', value: 'id', cols: 4 }
    ],
    MesaAyudaFilterReporteForm: [
      { field: 'textDatePicker', name: 'Fecha Inicio', nameid: 'fecha_inicio', default: true, cols: 6 },
      { field: 'textDatePicker', name: 'Fecha Final', nameid: 'fecha_final', default: true, cols: 6 },
      { field: 'selectDataServer', name: 'Tipo Actividad', nameid: 'tipo_actividad_id', url: '/empresa/tipo-actividades/show-solicitudes', cols: 6 },
      { field: 'selectDataServer', name: 'Tipo Servicio', nameid: 'servicio_id', url: '/catalogo/tipos-atencion', value: 'id', cols: 6 }
    ],
    // Configuraciones
    FamiliaCaracterisiricForm: [
      { field: 'selectDataServer', name: 'Caracteristica', nameid: 'caracteristica_id', url: '/catalogo/caracteristicas', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Orden', nameid: 'order', rules: true, cols: 12 }
    ],
    EmpleadoForm: [
      { field: 'text', type: 'text', name: 'Clave empleado', nameid: 'cve_empleado', rules: true, cols: 4 },
      { field: 'text', type: 'text', name: 'Nombres', nameid: 'nombres', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Apellidos', nameid: 'apellidos', rules: true, cols: 12 },
      { field: 'searchDataServer', name: 'Departamentos', nameid: 'departamento_id', objectname: 'departamento', value: 'id', url: '/empresa/departamentos/find', rules: true, cols: 12 }
    ],
    // Configuraciones / Accesos - USURARIO
    UsersForm: [
      { field: 'text', type: 'text', name: 'Nombre Usuario', nameid: 'usuario', rules: true, cols: 12 },
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'empleado_id', url: '/empresa/empleados/find', itemValue: 'id', rules: true, cols: 12 },
      { field: 'textEmail', type: 'email', name: 'Correo Electrónico', nameid: 'email', rules: true, cols: 12 },
      { field: 'text', type: 'password', name: 'Contraseña', nameid: 'password', rules: true, cols: 6 },
      { field: 'text', type: 'password', name: 'Confirmar Contraseña', nameid: 'confirmpassword', rules: true, cols: 6 }
    ],
    UsersUpdateForm: [
      { field: 'text', type: 'text', name: 'Nombre Usuario', nameid: 'usuario', rules: true, cols: 12 },
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'empleado_id', url: '/empresa/empleados/find', itemValue: 'id', rules: true, cols: 12 },
      { field: 'textEmail', type: 'email', name: 'Correo Electrónico', nameid: 'email', rules: true, cols: 12 }

    ],
    PasswordUpdateForm: [
      { field: 'text', type: 'password', name: 'Nueva Contraseña', nameid: 'new_password', rules: true, cols: 12 },
      { field: 'text', type: 'password', name: 'Confirmar Contraseña', nameid: 'other_new_password', rules: true, cols: 12 }
    ],
    // Configuraciones / Accesos - ROLES
    RoleForm: [
      { field: 'text', type: 'text', name: 'Clave Role', nameid: 'slug', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Nombre Role', nameid: 'nombre', rules: true, cols: 12 }
    ],
    // Configuraciones / Accesos - PERMISOS
    PermisosForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Clave permiso', nameid: 'slug', rules: true, cols: 12 },
      { field: 'textArea', name: 'descripción', nameid: 'descripcion', dimens: 'input-7-1', rules: true, cols: 12 }
    ],

    // Catalogo
    TiposDatosForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'textArea', name: 'Configuracion', nameid: 'default', dimens: 'input-7-1', rules: true, cols: 12 }
    ],
    CaracteristicasForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'selectDataServer', name: 'Tipo de Dato', nameid: 'tipo_dato_id', url: '/catalogo/tipo-datos', rules: true, cols: 12 }
    ],
    ProveedoresForm: [
      { field: 'text', type: 'text', name: 'RFC', nameid: 'rfc', rules: true, cols: 6 },
      { field: 'select', name: 'Tipo', nameid: 'tipo', items: ['fisica', 'moral'], rules: true, cols: 6 },
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 }
    ],
    TiposContratacionesForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Clave', nameid: 'clave', rules: true, cols: 12 }
    ],
    PartidasForm: [
      { field: 'text', type: 'text', name: 'Cuenta', nameid: 'cuenta', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'textArea', type: 'text', name: 'Descripción', nameid: 'descripcion', rules: true, cols: 12 }
    ],
    DepartamentosForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 }
    ],
    FamiliaForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'radioButton', name: '¿ Es de insumo ?', nameid: 'insumo', items: [{ name: 'SI', value: true }, { name: 'NO', value: false }], row: true, cols: 12 }
    ],
    MarcaForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 }
    ],
    ProcedenciaForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 }
    ],
    // MOVIMIENTOS
    MovimientosFilterForm: [
      { field: 'showMovsDataServer', name: '', nameid: 'movimientos', url: '/procesos/movimientos', default: '/procesos/movimientos', hidden: true, cols: 12 },
      { field: 'select', name: 'Tipo Movimiento', nameid: 'movs', items: ['todos', '4movs'], action: 'ShowFieldDinamic', isHidden: ['movimientos'], rules: true, cols: 12 }
    ],
    InventariosEquiposFilterForm: [
      { field: 'selectMultipleDataServer', name: 'Departamento', nameid: 'departamento_id', url: '/empresa/departamentos', search: true, rules: true, cols: 12 },
      { field: 'selectDataServer', name: 'Procedencia', nameid: 'procedencia_id', url: '/catalogo/procedencias', rules: 'Required', cols: 6 },
      { field: 'selectMultipleDataServer', name: 'Marca', nameid: 'marca_id', url: '/catalogo/marcas', search: true, rules: 'Required', cols: 6 }
    ],
    // ========== * ========== * ========== * ========== * ========== * ========== * \\
    // ========== * ========== * ========== * ========== * ========== * ========== * \\
    InsumosForm: [
      { field: 'searchDataServer', name: 'Buscar Insumo', nameid: 'insumo_id', url: '/insumos/picking', objecName: 'insumo', itemValue: 'id', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Cantidad', nameid: 'cantidad', rules: true, cols: 12 }
    ],
    incidenciaForm: [
      { field: 'selectGroupDataServer', name: 'Periodo', nameid: 'ejercicio_id', url: '/nomina/config/ejercicio/periodos', rules: true, cols: 12, default: true },
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'adscripcion_id', url: '/nomina/empleados-plazas/find', itemValue: 'id', rules: true, cols: 12 },
      { field: 'number', type: 'number', name: 'Asistencia', nameid: 'horas_asistencia', cols: 6 },
      { field: 'number', type: 'number', name: 'Faltas', nameid: 'horas_faltas', cols: 6 }
    ],
    fileIncidencia: [
      { field: 'fileInputDataServer', name: 'Layout Incidenias', nameid: 'file', rules: true, cols: 12 }
    ],
    cuentasEmpleadosForm: [
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'cve_empleado', url: '/rh/empleado/find', itemValue: 'cve_empleado', rules: true, cols: 12 },
      { field: 'selectDataServer', name: 'Banco', nameid: 'banco_id', url: '/nomina/bancos/show', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Cuenta Bancaria', nameid: 'cuenta', rules: false, cols: 6 },
      { field: 'text', type: 'text', name: 'Clabe Bancaria', nameid: 'clabe', rules: false, cols: 6 }
    ],

    roleForm: [
      { field: 'text', type: 'text', name: 'Clave Role', nameid: 'slug', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Nombre Role', nameid: 'nombre', rules: true, cols: 12 }
    ],
    AssignRoles: [
      { field: 'viewText', name: 'Nombre Colaborador', nameid: 'NombreCompleto', cols: 12 },
      { field: 'viewText', name: 'Nombre Usuario', nameid: 'usuario', cols: 12 },
      { field: 'selectDataServer', name: 'Rol', nameid: 'rol_id', url: '/empresa/roles', rules: true, cols: 12 }
    ],
    RemoveRol: [
      { field: 'messageViewText', name: 'Estas seguro de eliminar el rol ?', classMain: 'text-center ma-auto text-h3', cols: 12 },
      { field: 'messageViewText', name: 'no podra revertir este moviminiento !!', classMain: 'text-center ma-auto title', cols: 12 }
    ],

    updateAdscripcion: [
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'cve_empleado', url: '/rh/empleado/find', cols: 12, rules: true, itemValue: 'cve_empleado', action: 'findBillEmployee', isHidden: ['cuenta_id'] },
      { field: 'selectDataServer', name: 'Cuenta', nameid: 'cuenta_id', url: '/nomina/cuentas/show', cols: 12, rules: true, default: '/nomina/cuentas/show-by-employee/', params: {}, hidden: true },
      { field: 'selectDataServer', name: 'Plaza', nameid: 'plaza_id', url: '/nomina/config/plazas/show', cols: 12, rules: true },
      { field: 'searchDataServer', name: 'Departamento', nameid: 'departamento_id', url: '/config/departamentos/find', cols: 12, rules: true, itemValue: 'id' }
    ],
    contactoForm: [
      { field: 'radioButton', name: 'Tipo Contacto', nameid: 'tipo', items: ['TELEFONO', 'CORREO', 'MOVIL'], rules: true, row: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Contacto', nameid: 'contacto', rules: true, cols: 12 }
    ],
    direccionForm: [
      { field: 'text', type: 'text', name: 'Calle', nameid: 'calle', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Numero', nameid: 'numero', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Cruzamiento 1', nameid: 'cruzamiento1', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Cruzamiento 2', nameid: 'cruzamiento2', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Codigo postal', nameid: 'cp', rules: true, cols: 6 },
      { field: 'searchDataServer', name: 'Localidad', nameid: 'localidad_id', url: '/config/cat/localidad/find', itemValue: 'id', value: 'id', cols: 6 }
    ],
    SelectDepartamentosForm: [
      { field: 'selectMultipleDataServer', name: 'Departamento', nameid: 'departamento_id', url: '/empresa/departamentos', rules: true, cols: 12 }
    ],
    RangeDateTimeForm: [
      { field: 'textDatePicker', name: 'Fecha Inicio', nameid: 'fecha_inicio', default: true, cols: 6 },
      { field: 'textDatePicker', name: 'Fecha Final', nameid: 'fecha_final', default: true, cols: 6 }
    ],
    PreviewPdfForm: [
      { field: 'previewpdf', nameid: 'ruta', params: 'data', name: 'PDF', cols: 12 }
    ]
  },
  getters: {
    // Mesa Ayuda - Soliciudes
    get_MesaAyudaFilterForm (state) { return state.MesaAyudaFilterForm },
    get_MesaAyudaFilterReporteForm (state) { return state.MesaAyudaFilterReporteForm },
    // Configuraciones
    get_FamiliaCaracterisiricForm (state) { return state.FamiliaCaracterisiricForm },
    get_EmpleadoForm (state) { return state.EmpleadoForm },
    // Configuraciones / Accesos
    get_UsersForm (state) { return state.UsersForm },
    get_UsersUpdateForm (state) { return state.UsersUpdateForm },
    get_PasswordUpdateForm (state) { return state.PasswordUpdateForm },
    // Configuraciones / Accesos - USURARIO
    get_RoleForm (state) { return state.RoleForm },
    // Configuraciones / Accesos - ROLES
    get_PermisosForm (state) { return state.PermisosForm },
    // Catalogo
    get_TiposDatosForm (state) { return state.TiposDatosForm },
    get_CaracteristicasForm (state) { return state.CaracteristicasForm },
    get_DepartamentosForm (state) { return state.DepartamentosForm },
    get_FamiliaForm (state) { return state.FamiliaForm },
    get_MarcaForm (state) { return state.MarcaForm },
    get_ProcedenciaForm (state) { return state.ProcedenciaForm },
    get_ProveedoresForm (state) { return state.ProveedoresForm },
    get_TiposContratacionesForm (state) { return state.TiposContratacionesForm },
    get_PartidasForm (state) { return state.PartidasForm },

    get_MovimientosFilterForm (state) { return state.MovimientosFilterForm },

    get_InventariosEquiposFilterForm (state) { return state.InventariosEquiposFilterForm },

    // ===== * ===== * ===== * ===== * ===== * ===== * ===== * ===== \\
    // ===== * ===== * ===== * ===== * ===== * ===== * ===== * ===== \\
    get_InsumosForm (state) { return state.InsumosForm },
    get_AssignRoles (state) { return state.AssignRoles },
    get_RemoveRol (state) { return state.RemoveRol },
    get_SelectDepartamentosForm (state) { return state.SelectDepartamentosForm },
    get_RangeDateTimeForm (state) { return state.RangeDateTimeForm },
    get_PreviewPdfForm (state) { return state.PreviewPdfForm }
  },
  mutations: {},
  actions: {}
})
